import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import history from '../../../config/history';
// Local Deps
import './SupplierGrid.scss';

export default class SupplierGrid extends React.PureComponent {
  static propTypes = {
    suppliers: PropTypes.array.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    getSelectedSuppliers: PropTypes.func.isRequired,
    rawSelected: PropTypes.any.isRequired,
    selectAll: PropTypes.any.isRequired,
    iconMember: PropTypes.any.isRequired,
  };

  state = {
    data: this.props.suppliers,
  };

  toggleRow(id) {
    const newSelected = { ...this.props.rawSelected };
    if (newSelected[id]) {
      newSelected[id] = !this.props.rawSelected[id];
      if (!newSelected[id]) {
        delete newSelected[id];
      }
    } else {
      newSelected[id] = true;
    }

    const showButton = Object.keys(newSelected).length === 0 ? 0 : 2;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedSuppliers(Object.keys(newSelected));
  }

  toggleSelectAll() {
    const newSelected = {};

    if (this.props.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.cage] = true;
      });
    }
    const showButton = this.props.selectAll === 0 ? 1 : 0;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedSuppliers(Object.keys(newSelected));
  }

  render() {
    const columns = [
      {
        Header: 'Company',
        accessor: 'company',
        style: { textTransform: 'uppercase' },
      },
      {
        Header: 'CAGE',
        accessor: 'cage',
      },
      {
        Header: 'Address',
        accessor: 'address',
      },
      {
        Header: 'City',
        accessor: 'city',
      },
      {
        Header: 'State',
        accessor: 'state',
      },
      {
        Header: 'Zip',
        accessor: 'zip',
      },
      {
        Header: 'Point Of Contact',
        accessor: 'poc',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Phone',
        accessor: 'phone',
      },
    ];

    const { suppliers, iconMember } = this.props;
    if (iconMember) {
      columns.unshift({
        id: 'checkbox',
        accessor: '',
        Cell: cellProps => (
          <Checkbox
            checked={this.props.rawSelected[cellProps.original.cage] === true}
            onChange={() => this.toggleRow(cellProps.original.cage)}
          />
        ),
        Header: () => (
          <Checkbox
            checked={this.props.selectAll === 1}
            indeterminate={this.props.selectAll === 2}
            onChange={() => this.toggleSelectAll()}
          />
        ),
        sortable: false,
        width: 45,
      });
    }
    let suppliersToGrid = [];

    suppliersToGrid = suppliers;

    return (
      <div className="nf-sp_grid">
        <ReactTable
          data={suppliersToGrid}
          columns={columns}
          defaultPageSize={25}
          minRows={5}
          resizable
          // filterable
          noDataText="Please expand your search and try again"
          style={{
            width: '100%',
            maxWidth: '100%',
            height: '100%'
          }}
          getTableProps={() => ({
            style: {
              width: '100%',
              maxWidth: '100%',
              tableLayout: 'auto'
            }
          })}
          getTheadThProps={() => ({
            style: {
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: '#fff',
              whiteSpace: 'normal',
              overflow: 'visible'
            }
          })}
          getTrProps={() => ({
            style: {
              display: 'flex',
              flexShrink: 0,
              width: '100%'
            }
          })}
          getTdProps={(_, rowInfo, column) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: () => {
                  if (column.id !== 'checkbox') {
                    const cage = rowInfo.original.cage;
                    sessionStorage.removeItem("udHistory");
                    history.push(`details/?cage=${cage}`);
                  }
                },
                style: {
                  cursor: 'pointer',
                  whiteSpace: 'normal',
                  overflow: 'visible',
                  textOverflow: 'unset'
                },
              };
            }
            return {
              style: {
                whiteSpace: 'normal',
                overflow: 'visible',
                textOverflow: 'unset'
              }
            };
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/SupplierGrid/SupplierGrid.jsx